import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { showSnackbar } from '../../../../../Reducer/SnackbarReducer';
import Wait from './Wait';
import { useWaitDashboard1 } from './Wait_QUERY';
import { WAIT_STEP_STATUS } from './Wait_Schema';

/**
 * Step00_Wait 기능단
 * - useWaitDashboard1로 대시보드 데이터 조회
 * - 목록/다음단계/스텝 액션은 상위(RIS_CUSTOMF) 콜백과 연동
 */
function WaitF({
  onNextStep,
  onBackToList,
  onEnterStep,
  assessmentTitle = '',
  assessmentRsCd = null,
  assessmentRsMethod = '',
}) {
  const dispatch = useDispatch();
  const searchInfo = useSelector((s) => s.SearchInfo);

  const titleFromContext =
    assessmentTitle ||
    (searchInfo?.startDate
      ? `${dayjs(searchInfo.startDate).year()}년 위험성평가`
      : '');

  const titleForForm = assessmentTitle || titleFromContext;

  const { data, isLoading, isFetching } = useWaitDashboard1({
    custCd: searchInfo?.custCd,
    rsCd: assessmentRsCd,
    titleOverride: assessmentTitle,
    enabled: !!searchInfo?.custCd && Number(assessmentRsCd) > 0,
  });

  const progressDashboard = data?.progressDashboard;

  const displaySteps = useMemo(() => data?.steps ?? [], [data?.steps]);
  const ResolveRouteStepId = (step) =>
    step?.routeStepId || step?.stepId || null;
  const enterStepWithContext = (routeStepId) => {
    onEnterStep?.(routeStepId, {
      rsCd: assessmentRsCd,
      title: displayTitle,
      rsMethod: assessmentRsMethod,
    });
  };

  const displayTitle = data?.assessmentTitle || titleFromContext;

  const HandleBackToList = () => {
    onBackToList?.();
  };

  const HandleStartNextStep = () => {
    const target =
      displaySteps.find((s) => s.status === WAIT_STEP_STATUS.inProgress) ||
      displaySteps.find((s) => s.status === WAIT_STEP_STATUS.pending) ||
      displaySteps[0];
    const routeStepId = ResolveRouteStepId(target);
    if (!routeStepId) {
      onNextStep?.();
      return;
    }
    enterStepWithContext(routeStepId);
  };

  const HandleStepEdit = (stepId, step) => {
    const routeStepId = ResolveRouteStepId(step) || stepId;
    if (
      routeStepId === 'safetyInfo' ||
      routeStepId === 'riskAssessment' ||
      routeStepId === 'improvement'
    ) {
      enterStepWithContext(routeStepId);
      return;
    }
    dispatch(
      showSnackbar({
        message: `「${step?.title || stepId}」 수정 화면은 추후 연결 예정입니다.`,
        type: 'info',
      })
    );
  };

  const HandleStepContinue = (stepId, step) => {
    const routeStepId = ResolveRouteStepId(step) || stepId;
    if (
      routeStepId === 'safetyInfo' ||
      routeStepId === 'riskAssessment' ||
      routeStepId === 'improvement'
    ) {
      enterStepWithContext(routeStepId);
      return;
    }
    dispatch(
      showSnackbar({
        message: `「${step?.title || stepId}」 계속하기는 추후 연결 예정입니다.`,
        type: 'info',
      })
    );
  };

  return (
    <Wait
      assessmentTitle={displayTitle}
      overallProgressPercent={data?.overallProgressPercent ?? 0}
      steps={displaySteps}
      rsMethod={assessmentRsMethod}
      progressDashboard={progressDashboard}
      loading={isLoading || isFetching}
      onBackToList={HandleBackToList}
      onStartNextStep={HandleStartNextStep}
      onStepEdit={HandleStepEdit}
      onStepContinue={HandleStepContinue}
    />
  );
}

export default WaitF;
